"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var common_1 = require("@scuf/common");
var Item_1 = __importDefault(require("../Item/Item"));
var ToggleItem = /** @class */ (function (_super) {
    __extends(ToggleItem, _super);
    function ToggleItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genInput = function () {
            var _a = _this.props, type = _a.type, group = _a.group, label = _a.label, active = _a.active, onChange = _a.onChange;
            switch (type) {
                case 'checkbox':
                    return (React.createElement(common_1.Checkbox, { className: "toggle-item", label: label, onChange: onChange, checked: active }));
                case 'radio':
                    return (React.createElement(common_1.Radio, { className: "toggle-item", key: group + "-" + label, name: group, label: label, checked: active, onChange: onChange }));
                default:
                    return null;
            }
        };
        return _this;
    }
    ToggleItem.prototype.render = function () {
        var _a = this.props, type = _a.type, group = _a.group, label = _a.label, active = _a.active, onChange = _a.onChange, onClick = _a.onClick, rest = __rest(_a, ["type", "group", "label", "active", "onChange", "onClick"]);
        return React.createElement(Item_1.default, __assign({}, rest), this.genInput());
    };
    return ToggleItem;
}(React.Component));
exports.default = ToggleItem;
//# sourceMappingURL=ToggleItem.js.map